interface Props {
  color?: string;
  fontSize?: number | string;
}

const ArrowDown: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="15.557"
      height="8.778"
      viewBox="0 0 15.557 8.778"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
    >
      <defs></defs>
      <g transform="translate(14.143 7.364) rotate(180)">
        <path
          className="a"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          d="M12.729,0,6.364,6.364,0,0"
        />
      </g>
    </svg>
  );
};

export default ArrowDown;
